import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import Screen from './-components/screen'
import { pharmacyClient } from '@/connect'
import dayjs from 'dayjs'
import {z} from 'zod';
import { Loading } from '@/layouts/loading'

const SearchParams = z.object({
    page: z.number().default(1),
    pageSize: z.number().default(10),
    supplierId: z.string().default('all'),
    stockPointId: z.string().default('all')
});

type SearchParams = z.infer<typeof SearchParams>;
export const Route = createFileRoute('/(inventory)/branch/_layout/purchase-orders/')({
  component: Screen,
  validateSearch: SearchParams,
  loaderDeps: ({ search: { page, pageSize, supplierId, stockPointId } }) => ({
    page,
    pageSize,
    supplierId,
    stockPointId,
  }),
  pendingComponent: () => <Loading />,
  pendingMinMs: 1000,
  pendingMs: 1,
  loader: async ({deps}) => {
    const stockPoints = await pharmacyClient.getStockPoints({
      startDate: dayjs().subtract(30, 'day').unix(),
      endDate: dayjs().unix(),
    })
    const suppliers = await pharmacyClient.listSuppliers({
      page: 1,
      pageSize: 1000,
    })
    const purchaseOrders = await pharmacyClient.listPurchaseOrders({
      pageNumber: deps.page,
      pageSize: deps.pageSize,
      includeUsed: true,
      supplierId: deps.supplierId !== "all" ? deps.supplierId : "",
      stockPointId: deps.stockPointId !== "all" ? deps.stockPointId : "",
    })

    return {
      stockPoints: stockPoints,
      suppliers: suppliers,
      purchaseOrders: purchaseOrders,
    }
  },
})
